// extracted by mini-css-extract-plugin
module.exports = {"features":"styles_features__1Xo4q","feature":"styles_feature__ejHG6","illustration":"styles_illustration__2AUgh"};